import styled from 'styled-components';
export var CarouselSled = styled.div.withConfig({
  componentId: "sc-1jsm8jg-0"
})(["display:inline-flex;"]);
export var CarouselSledContainer = styled.div.withConfig({
  componentId: "sc-1jsm8jg-1"
})(["display:grid;grid-template-columns:repeat( ", ",min-content );grid-column-gap:", ";position:relative;transition:transform 0.4s ease-in-out;"], function (_ref) {
  var totalPages = _ref.totalPages;
  return totalPages || 0;
}, function (props) {
  return props.gap || 0;
});
export var CarouselItem = styled.div.withConfig({
  componentId: "sc-1jsm8jg-2"
})(["width:100%;user-select:none;img{-webkit-user-drag:none;}"]);